import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="w-full footer py-5 px-5 md:py-7 md:px-10 flex items-center">
      <div className="flex flex-col-reverse md:flex-row items-center justify-between w-full">
        <p className="text-sm font-light">
          Copyright © {currentYear} Seedwills. All Rights Reserved.
        </p>
        <div className="flex mb-2 sm:mb-0">
          <Link to={'https://seedwills.io/legal'} className="text-sm mr-3 font-semibold">Terms of Service</Link>
          <Link to={'https://seedwills.io/legal'} className="text-sm font-semibold">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
